export const GET_BRASAO = "brasao.GET_BRASAO";
export const SET_BRASAO = "brasao.SET_BRASAO";
